<div class="top-bg" role="banner">
  <div class="container">

    <mat-toolbar class="h-100 p-0">
      <div class="top-nav-content">
        <div class="logo-contents">
          <div class="logo" [hidden]="llttfPage">
            <a [routerLink]="logoHomePath" aria-label="Home"><img src="assets/u299.png" alt="BB Logo" /></a>
          </div>

          <div class="menu-container">
            <a class="menu-toggle" (click)="toggleMenu()">
              <img src="/assets/hamburger-black.svg" alt="Open Menu" id="hamburger" class="hamburger-icon" />
            </a>
          </div>

          <div class="user-profile">
            <div class="btn-grp">
            <button [hidden]="hideSignInButton" class="video-store-top-nav-buttons sign-in-button" (click)="navigate('/login')">
              <span ><i class="fa-solid fa-user"></i>&nbsp; {{signInText}} </span>              
           </button>
           <button [hidden]="!hideSignInButton" class="video-store-top-nav-buttons sign-in-button" (click)="navigate('/video-store-dashboard')">
            <span><i class="fa fa-play-circle"></i>&nbsp;{{videosText}}</span>
           </button>
           <button  [matMenuTriggerFor]="Usermenu" class="video-store-top-nav-buttons chevron-button">
            <i class="fa-solid fa-caret-down"></i>
           </button>
           <mat-menu #Usermenu="matMenu" class="dashboard-menu">
             <button mat-menu-item (click)="logout()" [hidden]="!hideSignInButton"><i class="fa fa-sign-out"></i> &nbsp;{{signOutText}}</button>
             <button mat-menu-item (click)="navigate('/contact')"><i class="fa fa-envelope"></i> &nbsp;{{contactUsText}}</button>
             <hr [hidden]="!hideSignInButton">
             <span class="topmenu-username">{{username}}</span>
           </mat-menu>
          </div>

          <div class="btn-grp">
           <button class="video-store-top-nav-buttons sign-in-button" (click)="openLanguageModal()">
            <i class="fa fa-globe"></i>&nbsp;<span>{{languageText}}</span>
         </button>
        </div>
        </div>

        <div class="navigation-menu">
          <div class="container">
            <ul class="menu" id="menuLinks" >
                <div class="insideMenuLink">
                  <a class="menu-toggle responsiveMenuClose" (click)="toggleMenu()">
                    <img src="/assets/cross.svg" alt="Open Menu" id="hamburger" class="hamburger-icon"/>
                  </a>
                <li class="menu-item" [hidden]="hideSignInButton" id="SignInLink">
                  <span alt="Dashboard Link" aria-label="SignIn" (click)="navigate('/login')"><i class="fa-solid fa-user"></i>&nbsp; {{signInText}}</span>
                </li>
                <li class="menu-item" [hidden]="!hideSignInButton" id="VideosLink">
                  <span alt="Dashboard Link" aria-label="Videos" (click)="navigate('/video-store-dashboard')"><i class="fa fa-play-circle"></i>&nbsp;{{videosText}}</span>
                </li>
                <li class="menu-item">
                  <span href="" (click)="navigate('/contact')"><i class="fa fa-envelope"></i> &nbsp;{{contactUsText}}</span>                   
                </li>
                <li class="menu-item">
                  <span (click)="openLanguageModal()"><i class="fa fa-globe"></i>&nbsp;<span>{{languageText}}</span></span>                   
                </li>
                <li class="menu-item" [hidden]="!hideSignInButton" id="Signout">
                  <span (click)="logout()" ><i class="fa fa-sign-out"></i> &nbsp;{{signOutText}}</span>
                </li>
                
          
                </div>
           </ul>
          </div>
          </div>

        </div>
      </div>

      <script>

      </script>
      </mat-toolbar>
      </div>
      </div>
      